export interface StoredAuth {
  token: string;
  refresh_token?: string;
  [key: string]: unknown;
}

function parseStoredAuth(key: string): StoredAuth | false {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return false;
    const parsed = JSON.parse(raw) as StoredAuth;
    return parsed?.token ? parsed : false;
  } catch {
    localStorage.removeItem(key);
    return false;
  }
}

export const isAuth = (): StoredAuth | false => parseStoredAuth('REACT_TOKEN_AUTH');

export const isLoginAsUser = (): StoredAuth | false => parseStoredAuth('REACT_TOKEN_AUTH_ORIGIN');
